import { render, staticRenderFns } from "./quotationDetail.vue?vue&type=template&id=fea26af0&scoped=true&"
import script from "./quotationDetail.vue?vue&type=script&lang=js&"
export * from "./quotationDetail.vue?vue&type=script&lang=js&"
import style0 from "./quotationDetail.vue?vue&type=style&index=0&id=fea26af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea26af0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fea26af0')) {
      api.createRecord('fea26af0', component.options)
    } else {
      api.reload('fea26af0', component.options)
    }
    module.hot.accept("./quotationDetail.vue?vue&type=template&id=fea26af0&scoped=true&", function () {
      api.rerender('fea26af0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/Quotation/quotationDetail.vue"
export default component.exports